<div class="dialog-shell">
  <div class="dialog-header">
    <div class="header-left">
      <img class="avatar avatar--lg" [src]="imageSrc" alt="Paciente" />
      <div class="header-text">
        <div class="title">{{ getNombre() || 'PACIENTE' }}</div>
        <div class="subtitle">
          <span class="chip" [class.chip-on]="p?.pinActivo" [class.chip-off]="!p?.pinActivo">
            <mat-icon>{{ p?.pinActivo ? 'lock' : 'lock_open' }}</mat-icon>
            <span>{{ p?.pinActivo ? 'PIN ACTIVO' : 'PIN INACTIVO' }}</span>
          </span>
        </div>
      </div>
    </div>

    <button mat-icon-button type="button" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body" *ngIf="!loading; else loadingTpl">
    <div class="datos-block">
      <h3 class="datos-titulo"><mat-icon>person</mat-icon>DATOS PERSONALES</h3>

      <div class="grid-3">
        <div class="datos-item">
          <span class="datos-label">NOMBRE</span>
          <span class="datos-valor">{{ getNombre() }}</span>
        </div>

        <div class="datos-item">
          <span class="datos-label">EDAD</span>
          <span class="datos-valor">{{ p?.edad ?? 'N/D' }} AÑOS</span>
        </div>

        <div class="datos-item">
          <span class="datos-label">GÉNERO</span>
          <span class="datos-valor">{{ getGenero() }}</span>
        </div>

        <div class="datos-item">
          <span class="datos-label">NACIMIENTO</span>
          <span class="datos-valor">{{ p?.fechaNacimiento | date:'yyyy-MM-dd' }}</span>
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <div class="datos-block">
      <h3 class="datos-titulo"><mat-icon>contact_mail</mat-icon>CONTACTO Y DOMICILIO</h3>

      <div class="grid-2">
        <div class="datos-item">
          <span class="datos-label">CORREO</span>
          <span class="datos-valor break-anywhere">{{ p?.email ?? 'N/D' }}</span>
        </div>

        <div class="datos-item">
          <span class="datos-label">TELÉFONO</span>
          <span class="datos-valor">{{ p?.movil ? (p?.movil | formatMobile) : 'N/D' }}</span>
        </div>

        <div class="datos-item full-width">
          <span class="datos-label">DIRECCIÓN</span>
          <span class="datos-valor">
            {{ p?.domicilio ?? '' }}
            <ng-container *ngIf="p?.codigoPostal">, {{ p?.codigoPostal }}</ng-container>
            <ng-container *ngIf="p?.asentamiento">, {{ p?.asentamiento }}</ng-container>
            <ng-container *ngIf="p?.municipio">, {{ p?.municipio }}</ng-container>
            <ng-container *ngIf="p?.estado">, {{ p?.estado }}</ng-container>
          </span>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button mat-flat-button color="primary" type="button" (click)="close()">CERRAR</button>
    </div>
  </div>

  <ng-template #loadingTpl>
    <div class="loading">
      CARGANDO...
    </div>
  </ng-template>
</div>
